import dayjs from 'dayjs'

export default function appDate (input: string, ignoreValues: string[] = []) {
  if (ignoreValues.includes(input)) return input
  const result = dayjs(input).format('MM/DD/YYYY')
  if (result === 'Invalid Date') {
    return ''
  }
  return result
}
